import { ISaveAsPatchContext } from './saveAsPatchModalContext';

export enum SaveAsPatchActionTypes {
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_TYPE_OF_CHANGES = 'SET_TYPE_OF_CHANGES',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	SET_PROPERTIES = 'SET_PROPERTIES',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetInitialFormData {
	type: SaveAsPatchActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: ISaveAsPatchContext['initialFormData'];
	};
}

interface ISetTypeOfChanges {
	type: SaveAsPatchActionTypes.SET_TYPE_OF_CHANGES;
	payload: {
		typeOfChanges: ISaveAsPatchContext['typeOfChanges'];
		IDsSelectedRestaurant: ISaveAsPatchContext['IDsSelectedRestaurant'];
	};
}

interface ISetIDsRestaurant {
	type: SaveAsPatchActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: ISaveAsPatchContext['IDsSelectedRestaurant'];
	};
}

interface ISetProperties {
	type: SaveAsPatchActionTypes.SET_PROPERTIES;
	payload: {
		selectedProperties: ISaveAsPatchContext['selectedProperties'];
	};
}

interface IChangeActivationSchedule {
	type: SaveAsPatchActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: ISaveAsPatchContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: SaveAsPatchActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: ISaveAsPatchContext['deactivationSchedule'];
	};
}

interface IChangeTypeOfModalWindow {
	type: SaveAsPatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ISaveAsPatchContext['typeOfModalWindow'];
	};
}

interface IResetFields {
	type: SaveAsPatchActionTypes.RESET_FIELDS;
}

export type TSaveAsPatchAction =
	| ISetInitialFormData
	| ISetTypeOfChanges
	| ISetIDsRestaurant
	| ISetProperties
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| IChangeTypeOfModalWindow
	| IResetFields;
